import { format } from 'date-fns';
export function getBadgeFileName(accountDisplayName) {
    const displayName = accountDisplayName === null || accountDisplayName === void 0 ? void 0 : accountDisplayName.replace(' ', '_');
    const dateAndTime = format(new Date(), 'MMddyyyy_HHmmss');
    return `${['badge', displayName, dateAndTime].filter((val) => val).join('_')}.pdf`;
}
